export default {
  FETCHED_ALL: 'FETCHED_ALL_MARKET_GROUPS',
  FETCHED_MULTIPLE: 'FETCHED_MARKET_GROUPS',
  FETCHED_SINGLE: 'FETCHED_MARKET_GROUP',
  DELETED_SINGLE: 'DELETED_MARKET_GROUP',
};
